import { render, staticRenderFns } from "./HotelPlanInfo.vue?vue&type=template&id=4350af12&scoped=true"
import script from "./HotelPlanInfo.vue?vue&type=script&lang=js"
export * from "./HotelPlanInfo.vue?vue&type=script&lang=js"
import style0 from "./HotelPlanInfo.vue?vue&type=style&index=0&id=4350af12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350af12",
  null
  
)

export default component.exports